export default "__VITE_ASSET__Co1cmJ9V__"